'use strict'

import axios from 'axios'

// jsRenderのdelimitersを変更する
$.views.settings.delimiters('[[', ']]')

$(function () {
  const path = location.pathname
  const last = path.split('/').pop()
  if (last !== 'preview') {
    axios.get(`/api/1.0.0/recommended_apps?exclude=${$('#js-app-detail-apps').attr('data-exclude-app-id')}&count=6`).then((response) => {
      if (!response.data.apps) {
        return
      }
      $('#js-app-detail-apps-ul').append(
        $('#js-app-detail-app-li').render(response.data)
      ).append($('#js-app-detail-app-li-more').render())
      $('#js-app-detail-apps').css('display', 'block')
    }).catch((error) => {
      console.warn(error)
    })
  }

  // 画面幅1200px以下の時のFixed Header調整（横スクロール対応）
  let fixedHeaderFlag
  const $window = $(window)
  const $fixedHeader = $('.js-fixedHeader')

  $window.on('resize load', () => {
    fixedHeaderFlag = $window.width() < 1200
  })

  $window.on('scroll', () => {
    if (fixedHeaderFlag) {
      $fixedHeader.css({
        'left': -$window.scrollLeft(),
        'width': 'auto'
      })
    } else {
      $fixedHeader.css({
        'left': 0,
        'width': '100%'
      })
    }
  })
})

window.onload = () => {
  const dialogs = Array.from(document.querySelectorAll('.js-HowToRelationAppData'))
  Array.from(document.querySelectorAll('.js-showHowToRelationAppData')).map(item => {
    item.addEventListener('click', () => {
      dialogs.map(dialog => {
        dialog.classList.add('is-active')
      })
    })
  })
  Array.from(document.querySelectorAll('.js-dismissHowToRelationAppData')).map(item => {
    item.addEventListener('click', () => {
      dialogs.map(dialog => {
        dialog.classList.remove('is-active')
      })
    })
  })
}
